module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ympager",
    attrs: {
      "id": _vm.pagerId
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1897c7d9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YmPager.vue
// module id = 580
// module chunks = 2